import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const serverURL = process.env.REACT_APP_URL;

export const createVendor = createAsyncThunk(
  "vendor/createVendor",
  async (vendorData, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${serverURL}/api/vendors`, vendorData);
      return response.data; // Assuming API returns created vendor data
    } catch (error) {
      return rejectWithValue(error.response.data || "Failed to create vendor");
    }
  }
);

const initialState = {
  formData: {
    state: "",
    division: "",
    district: "",
    city: "",
    vendorBusinessName: "",
    pinCode: "",
    typeOfBusiness: "",
    emailAddress: "",
    ownerName: "",
    ownerPrimaryContactNo: "",
    ownerSecondaryContactNo: "",
    address: "",
    landmark: "",
    businessLocation: "",
    website: "",
    bankAccountHolderName: "",
    reliability: "",
    yearsInBusiness: "",
    numberOfEmployees: "",
    numberOfSkilledManpower: "",
    numberOfUnskilledManpower: "",
    registeredInESIPF: false,
    GSTIN: "",
    PANNumber: "",
    bankAccountNumber: "",
    bankName: "",
    bankIFSCCode: "",
    chequeBookImageURL: "",
    avgTurnoverLast3Years: "",
    productionArea: "",
    paymentTerms: "",
    status: "Active",
    auditStatus: "Unverified",
    reasonForBlacklisted: "",
    profilePhoto: "",
    creditLimit: "",
    scalingFactors: [],
    certifications: [],
    imagesUploaded: [],
    certificateUploaded: [],
    addedBy:
      typeof window !== "undefined" ? localStorage.getItem("userId") : "",
    updatedBy:
      typeof window !== "undefined" ? localStorage.getItem("userId") : "",
  },
  errors: {},
  isGstVerified: false,
  saveButtonClicked: false,
  doesVendorRegistered: false,
  loading: false,
  errorMessage: null,
};

const vendorFormSlice = createSlice({
  name: "vendorForm",
  initialState,
  reducers: {
    updateFormField: (state, action) => {
      const { name, value } = action.payload;
      state.formData[name] = value;
      state.errors[name] = ""; // Clear field error on change
    },
    setFieldError: (state, action) => {
      const { name, message } = action.payload;
      state.errors[name] = message;
    },

    setSaveButtonClicked: (state, action) => {
      state.saveButtonClicked = action.payload;
    },
    setIsGstVerified: (state, action) => {
      state.isGstVerified = action.payload;
    },
    setForm: (state, action) => {
      state.formData = action.payload;
      state.errors = {};
    },
    resetForm: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(createVendor.pending, (state) => {
        state.loading = true;
        // You can optionally add loading state here if needed
      })
      .addCase(createVendor.fulfilled, (state, action) => {
        state.loading = false;
        const vendorId = action.payload?.vendor?._id;
        const token = action.payload?.token;

        if (vendorId && token) {
          localStorage.setItem("vendorId", vendorId);
          localStorage.setItem("vendorToken", token);
        }

        state.errors = {};
        state.errorMessage = action.payload?.message || "";
      })
      .addCase(createVendor.rejected, (state, action) => {
        state.loading = false;
        localStorage.removeItem("vendorId");
        localStorage.removeItem("vendorToken");
        state.errorMessage =
          action.payload?.message || action.payload || "Vendor creation failed";
      });
  },
});

export const {
  updateFormField,
  setFieldError,
  validateAllFields,
  setSaveButtonClicked,
  setForm,
  resetForm,
  setIsGstVerified,
} = vendorFormSlice.actions;

export default vendorFormSlice.reducer;
